namespace $.$$ {
	export class $shm_hitalama_components_menu extends $.$shm_hitalama_components_menu {
		title() { return this.definition().display_name() }
		version_label() { return this.versions().label() }
		links() { return [ 'preview', 'settings', 'code', 'tests', 'drafts', 'history' ].map( name => this.Link( name ) ) }
		link_title( name: string ) { return { preview: 'Просмотр', settings: 'Параметры', code: 'Код', tests: 'Тесты', drafts: 'Черновики', history: 'История версий' }[name] ?? '' }
		link_content( name: string ) { return [ this.link_title( name ), ...( name === 'drafts' && this.drafts().ids().length ? [ this.Drafts_count() ] : [] ) ] }
		drafts_count() { return '(' + this.drafts().ids().length + ')' }
		link_arg( name: string ) { return { application_tab: name, application_version: null, application_draft: null, application_draft_edit: null } }
		link_current( name: string ) { return this.tab() === name }
	}
}
